import { useEffect, useMemo } from 'react'

import { Carousel } from '@tribeplatform/react-ui-kit/Carousel'

import { useMediaModal } from '../../../MediaModal/MediaModalProvider.js'
import { useChatContext } from '../../index.js'

import { ComposerAttachmentItem } from './ComposerAttachmentItem.js'
import { ComposerEmbedRenderer } from './ComposerEmbedRenderer.js'

export const ComposerAttachments = () => {
  const {
    draftMessage,
    uploadingAttachments,
    removeAttachments,
    removeEmbeds,
  } = useChatContext()
  const { pushSlide, removeSlide } = useMediaModal()

  const orderedAttachments = useMemo(() => {
    return [...draftMessage.attachments].sort((a, b) => {
      if (a.type === 'image' && b.type !== 'image') {
        return -1
      }
      return 1
    })
  }, [draftMessage.attachments])

  useEffect(() => {
    orderedAttachments.forEach(attachment => {
      pushSlide(attachment.uploadedFile)
    })

    return () => {
      orderedAttachments.forEach(attachment => {
        removeSlide(attachment.uploadedFile?.id)
      })
    }
  }, [orderedAttachments, pushSlide, removeSlide])

  const renderAttachments = useMemo(() => {
    return orderedAttachments.map(attachment => (
      <ComposerAttachmentItem
        key={attachment.id}
        attachment={attachment}
        isUploading={uploadingAttachments.some(
          uploadingAttachment => uploadingAttachment.id === attachment.id,
        )}
        onRemove={attachment => removeAttachments([attachment])}
      />
    ))
  }, [orderedAttachments, uploadingAttachments, removeAttachments])

  const renderedEmbedAttachments = useMemo(() => {
    return draftMessage.embeds.map(embed => (
      <ComposerEmbedRenderer
        key={embed.id}
        embed={embed}
        onRemove={embed => removeEmbeds([embed])}
      />
    ))
  }, [draftMessage.embeds, removeEmbeds])

  const renderedAttachments = useMemo(() => {
    return [...renderAttachments, ...renderedEmbedAttachments]
  }, [renderAttachments, renderedEmbedAttachments])

  if (renderedAttachments.length === 0) {
    return null
  }

  return (
    <div className="shrink-0">
      <Carousel
        className="py-[11px] max-h-[5rem]"
        items={renderedAttachments}
      />
    </div>
  )
}
